const MONTHS = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];
const THIS_MONTH = new Date().getMonth();

const getMonthName = (month = THIS_MONTH) => MONTHS[month];

export default getMonthName;
